// tr土耳其
export default {
    CustomSelect: {
        '请选择': 'Seçiniz',
    },
    TopNav: {
        '创作者': 'Oluşturucu',
        '游客': 'Ziyaretçi',
        '请登录后体验完整功能': 'Tam işlevsellik için lütfen giriş yapın',
        '登录': 'Giriş Yap',
        '免费试用': 'Ücretsiz Dene',
        '退出登录': 'Çıkış Yap',
        '个人中心': 'Hesabım',
        '我的视频': 'Videolarım',
        '额度管理': 'Kredi Yönetimi',
        '首页': 'Ana Sayfa',
        'AI创作': 'AI Oluşturma',
        '多参考': 'Çoklu Referans',
        '文本视频': 'Metinden Videoya',
        '图片视频': 'Görselden Videoya',
        '文生图': 'Metinden Görsele',
        '图生图': 'Görselden Görsele',
        '会员中心': 'Üyelik Merkezi',
        '概览': 'Genel Bakış',
        '我的创作': 'Oluşturduklarım',
        '账单管理': 'Fatura Yönetimi',
        '生成任务': 'Oluşturma Görevleri',
        '价格': 'Fiyatlar',
        '新闻资讯': 'Haberler',
        '确定要退出登录吗？': 'Çıkış yapmak istediğinize emin misiniz?',
        '提示': 'İpucu',
        '确定': 'Onayla',
        '取消': 'İptal',
        '退出成功': 'Başarıyla çıkış yapıldı',
        '视频展示': 'Video sunumu'
    },
    AiLayout: {
        'AI创作中心': 'AI Oluşturma Merkezi',
        '视频生成': 'Video Oluşturma',
        '图片生成': 'Görsel Oluşturma',
        '我的作品': 'Eserlerim',
        '我的创作': 'Oluşturduklarım',
        '今日剩余额度': 'Bugün Kalan Kredi',
        '多参考': 'Çoklu Referans',
        '文本视频': 'Metinden Videoya',
        '图片视频': 'Görselden Videoya',
        '文生图': 'Metinden Görsele',
        '图生图': 'Görselden Görsele',
    },
    HomeLayout: {
        '下一代AI视频生成平台': 'Yeni nesil AI video oluşturma platformu, fikirleri anında gerçeğe dönüştürün',
        '产品': 'Ürünler',
        'AI视频': 'AI Video',
        '价格方案': 'Fiyat Planları',
        '新闻资讯': 'Haberler',
        '支持': 'Destek',
        '帮助中心': 'Yardım Merkezi',
        'API文档': 'API Dokümanı',
        '常见问题': 'SSS',
        '法律': 'Yasal',
        '服务条款': 'Hizmet Şartları',
        '隐私政策': 'Gizlilik Politikası',
        '使用协议': 'Kullanım Sözleşmesi',
        '版权所有': 'Tüm hakları saklıdır',
        '客服邮箱': 'Destek E-postası',
        '复制邮箱': 'E-postayı Kopyala',
        '开发中': 'Geliştirme aşamasında, takipte kalın!',
        '链接已复制到剪贴板': 'Bağlantı panoya kopyalandı',
    },
    MyLayout: {
        '创作者': 'Oluşturucu',
        '退出登录': 'Çıkış Yap',
        '概览': 'Genel Bakış',
        '我的创作': 'Oluşturduklarım',
        '会员中心': 'Üyelik Merkezi',
        '额度管理': 'Kredi Yönetimi',
        '账单管理': 'Fatura Yönetimi',
        '生成任务': 'Oluşturma Görevleri',
        '确定要退出登录吗？': 'Çıkış yapmak istediğinize emin misiniz?',
        '提示': 'İpucu',
        '确定': 'Onayla',
        '取消': 'İptal',
        '退出成功': 'Başarıyla çıkış yapıldı'
    },
    Image: {
        "文本生成图片": "Metinden Görsele",
        "图片生成图片": "Görselden Görsele",
        "用文字描述": "İstediğiniz görüntüyü kelimelerle açıklayın",
        "上传图片素材": "Görsel materyali yükleyin, çoklu görsel oluşturmayı destekler",
        "图片描述": "Görsel Açıklaması",
        "描述您想要的图片": "Oluşturmak istediğiniz görselin içeriğini ayrıntılı olarak açıklayın, Türkçe veya İngilizce desteklenir...",
        "提示描述越详细效果越好": "İpucu: Açıklama ne kadar ayrıntılı olursa, oluşturma sonucu o kadar iyi olur",
        "图片素材": "Görsel Materyali",
        "预览图片": "Önizleme",
        "上传图片": "Görsel Yükle",
        "支持格式JPGPNG": "JPG, PNG formatlarını destekler",
        "最多": "Maksimum",
        "张图片": "görsel",
        "超过大小限制": "10MB sınırını aşıyor",
        "不是图片文件": "Geçerli bir görsel dosyası değil",
        "最多上传": "Maksimum yükleme",
        "请先上传图片": "Lütfen önce görsel materyali yükleyin",
        "请选择要生成的图片": "Lütfen oluşturulacak görseli seçin",
        "生成结果": "Oluşturma Sonucu",
        "重新生成成功": "Yeniden oluşturma başarılı",
        "模型": "AI Modeli",
        "请选择模型": "Lütfen oluşturma modelini seçin",
        "分辨率": "Çıktı Çözünürlüğü",
        "请选择分辨率": "Lütfen çözünürlüğü seçin",
        "图片比例": "Görsel Oranı",
        "补充描述": "Ek Açıklama (isteğe bağlı)",
        "补充描述提示": "İsteğe bağlı: Görselde olmasını istediğiniz ek efektleri veya stilleri açıklayın",
        "开始绘制": "Çizmeye Başla",
        "开始生成": "Oluşturmaya Başla",
        "生成中": "Oluşturuluyor, lütfen bekleyin...",
        "生成成功": "Başarılı",
        "图片生成成功": "Görsel başarıyla oluşturuldu!",
        "作品已保存到我的作品": "Eser 'Eserlerim'e kaydedildi",
        "继续创作": "Oluşturmaya Devam Et",
        "查看作品": "Eseri Görüntüle",
        "请输入图片描述": "Lütfen görsel açıklamasını girin"
    },
    MyCreation: {
        '我的创作': 'Oluşturduklarım',
        '查看和管理您的所有作品': 'Tüm eserlerinizi görüntüleyin ve yönetin',
        '预览': 'Önizleme',
        '下载': 'İndir',
        '编辑': 'Düzenle',
        '分享': 'Paylaş',
        '删除': 'Sil',
        '暂无作品': 'Eser yok',
        '去创作': 'Oluşturmaya Git',
        '确定删除': 'Silme Onayı',
        '确定要删除作品': 'Eseri silmek istediğinize emin misiniz',
        '吗？': '?',
        '此操作不可恢复': 'Bu işlem geri alınamaz, lütfen dikkatli olun!',
        '取消': 'İptal',
        '分享作品': 'Eseri Paylaş',
        '复制链接': 'Bağlantıyı Kopyala',
        '全部': 'Tümü',
        '视频': 'Video',
        '图片': 'Görsel',
        '正在下载:': 'İndiriliyor: ',
        '链接已复制到剪贴板': 'Bağlantı panoya kopyalandı',
        '删除成功': 'Başarıyla silindi'
    },
    Video: {
        "文本生成视频": "Metinden Videoya",
        "图片生成视频": "Görselden Videoya",
        "智能视频生成": "Akıllı Video Oluşturma",
        "输入文字描述": "Metin açıklaması girin",
        "上传1-9张图片": "1-9 görsel yükleyin",
        "上传图片视频音频": "Görsel/Video/Ses Yükle",
        "视频描述": "Video Açıklaması",
        "描述您想要的视频场景": "İstediğiniz video sahnesini açıklayın",
        "提示": "İpucu",
        "图片素材": "Görsel Materyali",
        "最多上传": "Maksimum yükleme",
        "张": "görsel",
        "预览": "Önizleme",
        "上传图片": "Görsel Yükle",
        "支持格式": "JPG, PNG formatları, dosya başına maksimum 10MB, maksimum",
        "AI": "AI akıllıca birleştirir ve akıcı geçiş efektleri oluşturur",
        "动态描述": "Hareket Açıklaması",
        "描述您希望图片如何动起来": "Görselin nasıl hareket etmesini istediğinizi açıklayın",
        "个": "öğe",
        "上传视频": "Video Yükle",
        "上传音频": "Ses Yükle",
        "描述您希望视频呈现的效果": "İstediğiniz video efektini açıklayın",
        "模型": "Model",
        "请选择模型": "Lütfen modeli seçin",
        "分辨率": "Çözünürlük",
        "请选择分辨率": "Lütfen çözünürlüğü seçin",
        "宽高比": "En Boy Oranı",
        "视频时长": "Video Süresi",
        "生成音频": "Ses Oluştur",
        "开启音效": "Ses Efektlerini Aç",
        "静音模式": "Sessiz Mod",
        "音频提示": "İpucu: Yüklenen ses arka plan müziği olarak kullanılacaktır, ses yüklenmezse AI otomatik olarak müzik oluşturacaktır",
        "开始生成": "Oluşturmaya Başla",
        "积分": "Kredi",
        "生成中": "Oluşturuluyor",
        "生成成功": "Başarılı",
        "视频生成成功！": "Video başarıyla oluşturuldu!",
        "作品已保存到": "Eser 'Eserlerim'e kaydedildi",
        "继续创作": "Oluşturmaya Devam Et",
        "查看作品": "Eseri Görüntüle",
        "视频预览": "Video Önizleme",
        "关闭": "Kapat",
        "下载视频": "Videoyu İndir",
        "您的浏览器不支持视频播放": "Tarayıcınız video oynatmayı desteklemiyor",
        "生成进度": "Oluşturma İlerlemesi",
        "描述": "Açıklama",
        "时长": "Süre",
        "秒": "saniye",
        "视频素材": "Video Materyali",
        "音频素材": "Ses Materyali",
        "双图融合模式": "Çift Görsel Füzyon Modu",
        "开始下载视频": "Video İndirmeyi Başlat",
        "请输入视频描述": "Lütfen video açıklamasını girin",
        "请至少上传一张图片": "Lütfen en az bir görsel yükleyin",
        "请至少上传一张图片或一个视频": "Lütfen en az bir görsel veya bir video yükleyin",
        "最多只能上传": "Maksimum yükleme",
        "超过": "Aşıyor",
        "限制": "sınır",
        "不是图片文件": "Geçerli bir görsel dosyası değil",
        "不是视频文件": "Geçerli bir video dosyası değil",
        "不是音频文件": "Geçerli bir ses dosyası değil"
    },
    Forgot: {
        "找回密码": "Şifremi Kurtar",
        "请输入您的邮箱，我们将发送验证码": "E-postanızı girin, size bir doğrulama kodu göndereceğiz",
        "密码重置成功，请使用新密码登录": "Şifre başarıyla sıfırlandı, lütfen yeni şifrenizle giriş yapın",
        "密码重置成功": "Şifre başarıyla sıfırlandı",
        "您的密码已成功重置，请使用新密码登录": "Şifreniz başarıyla sıfırlandı, lütfen yeni şifrenizle giriş yapın",
        "立即登录": "Hemen Giriş Yap",
        "邮箱": "E-posta",
        "请输入注册邮箱": "Lütfen kayıtlı e-postayı girin",
        "发送验证码": "Doğrulama Kodu Gönder",
        "请输入验证码": "Lütfen doğrulama kodunu girin",
        "验证码": "Doğrulama Kodu",
        "新密码": "Yeni Şifre",
        "设置新密码": "Yeni Şifre Belirle",
        "确认新密码": "Yeni Şifreyi Onayla",
        "再次输入新密码": "Yeni şifreyi tekrar girin",
        "重置密码": "Şifreyi Sıfırla",
        "返回登录": "Girişe Dön",
        "验证中": "Doğrulanıyor",
        "重置中": "Sıfırlanıyor",
        "弱": "Zayıf",
        "中": "Orta",
        "强": "Güçlü",
        "请输入邮箱地址": "Lütfen e-posta adresini girin",
        "请输入正确的邮箱格式": "Lütfen geçerli bir e-posta formatı girin",
        "验证码应为6位数字": "Doğrulama kodu 6 haneli olmalıdır",
        "请输入新密码": "Lütfen yeni bir şifre girin",
        "密码至少需要6位": "Şifre en az 6 karakter olmalıdır",
        "请再次输入新密码": "Lütfen yeni şifreyi tekrar girin",
        "两次输入的密码不一致": "Girilen şifreler eşleşmiyor",
        "验证码已发送": "Doğrulama kodu gönderildi"
    },
    Login: {
        "下一代AI视频生成平台": "Yeni nesil AI video oluşturma platformu",
        "一键生成": "Tek Tıkla Oluştur",
        "支持4K超高清输出": "4K Ultra HD çıktı desteği",
        "多种风格模板任选": "Çeşitli stil şablonları arasından seçim yapın",
        "商用授权无忧使用": "Ticari lisans, gönül rahatlığıyla kullanın",
        "欢迎回来": "Tekrar hoş geldiniz",
        "登录您的账号继续创作": "Oluşturmaya devam etmek için hesabınıza giriş yapın",
        "邮箱": "E-posta",
        "请输入邮箱地址": "Lütfen e-posta adresini girin",
        "密码": "Şifre",
        "请输入您的密码": "Lütfen şifrenizi girin",
        "记住我": "Beni Hatırla",
        "忘记密码？": "Şifremi unuttum?",
        "登录": "Giriş Yap",
        "登录中": "Giriş yapılıyor",
        "还没有账号？": "Hesabınız yok mu?",
        "立即注册": "Hemen Kaydol",
        "请输入正确的邮箱格式": "Lütfen geçerli bir e-posta formatı girin",
        "请输入密码": "Lütfen şifreyi girin",
        "密码至少需要6位": "Şifre en az 6 karakter olmalıdır",
        "密码不能超过20位": "Şifre 20 karakteri aşamaz",
        "登录成功": "Giriş başarılı"
    },
    Register: {
        "创建账号": "Hesap Oluştur",
        "开始您的AI视频创作之旅": "AI video oluşturma yolculuğunuza başlayın",
        "姓名": "Ad Soyad",
        "请输入您的姓名": "Lütfen adınızı girin",
        "邮箱": "E-posta",
        "请输入邮箱地址": "Lütfen e-posta adresini girin",
        "获取验证码": "Doğrulama Kodu Al",
        "验证码": "Doğrulama Kodu",
        "请输入验证码": "Lütfen doğrulama kodunu girin",
        "密码": "Şifre",
        "设置密码": "Şifre Belirle",
        "确认密码": "Şifreyi Onayla",
        "再次输入密码": "Şifreyi tekrar girin",
        "我已阅读并同意": "Okudum ve kabul ediyorum",
        "服务条款": "Hizmet Şartları",
        "和": "ve",
        "隐私政策": "Gizlilik Politikası",
        "注册中": "Kaydediliyor",
        "已有账号？": "Zaten hesabınız var mı?",
        "立即登录": "Hemen Giriş Yap",
        "弱": "Zayıf",
        "中": "Orta",
        "强": "Güçlü",
        "请输入姓名": "Lütfen adı girin",
        "姓名至少需要2个字符": "Ad en az 2 karakter olmalıdır",
        "姓名不能超过20个字符": "Ad 20 karakteri aşamaz",
        "请输入正确的邮箱格式": "Lütfen geçerli bir e-posta formatı girin",
        "验证码应为6位数字": "Doğrulama kodu 6 haneli olmalıdır",
        "请输入密码": "Lütfen şifreyi girin",
        "密码至少需要6位": "Şifre en az 6 karakter olmalıdır",
        "密码不能超过20位": "Şifre 20 karakteri aşamaz",
        "请再次输入密码": "Lütfen şifreyi tekrar girin",
        "两次输入的密码不一致": "Girilen şifreler eşleşmiyor",
        "验证码已发送": "Doğrulama kodu gönderildi",
        "注册成功": "Kayıt başarılı"
    },
    Faq: {
        '常见问题': 'Sık Sorulan Sorular',
        '您在使用过程中遇到的问题': 'Kullanım sırasında karşılaştığınız sorunların cevaplarını burada bulun',
        '搜索您的问题': 'Sorunuzu arayın...',
        '没有找到相关的问题': 'İlgili soru bulunamadı',
        '查看全部问题': 'Tüm soruları görüntüle',
        '没有找到您想要的答案？': 'Aradığınız cevabı bulamadınız mı?',
        '我们的客服团队随时为您提供帮助': 'Destek ekibimiz size yardım etmek için her zaman hazırdır',
        '复制客服邮箱': 'Destek e-postasını kopyala',
        '链接已复制到剪贴板': 'Bağlantı panoya kopyalandı'
    },
    Home: {
        '立即订阅': 'Hemen abone ol',
        'AI视频生成新时代': 'AI Video Oluşturmanın Yeni Çağı',
        '用文字创造': 'Kelimelerle Yarat',
        '无限视频': 'Sınırsız Video',
        '让每个人都能成为视频创作者': 'Herkesin video oluşturucusu olmasını sağlayın. Benzersiz, yüksek kaliteli AI videoları elde etmek için sadece bir metin açıklaması girin.',
        '免费开始': 'Ücretsiz Başla',
        '观看演示': 'Demoyu İzle',
        'AI生成': 'AI ile Oluştur',
        'AI视频': 'AI Video',
        '三步轻松生成专业视频': 'Profesyonel videoları üç adımda kolayca oluşturun',
        '输入提示词': 'İpucu girin',
        '用文字描述您想要的视频内容': 'İstediğiniz video içeriğini kelimelerle açıklayın, ne kadar ayrıntılı olursa o kadar iyi',
        '智能生成': 'Akıllı Oluşturma',
        'AI模型自动理解并创作': 'AI modeli otomatik olarak anlar ve oluşturur, işleme birkaç dakika içinde tamamlanır',
        '下载作品': 'Eseri İndir',
        '高清视频生成完成': 'HD video oluşturma tamamlandı, hemen indirmeye ve kullanmaya hazır',
        'AI视频生成': 'AI Video Oluşturma',
        '精彩视频': 'Bir metin açıklaması girin, AI sizin için harika bir video oluşturacaktır',
        '描述您想要的视频场景': 'İstediğiniz video sahnesini açıklayın, örneğin: Kiraz ağacının altında oynayan bir kedi, güneş ışığı yaprakların arasından süzülüyor...',
        '生成中': 'Oluşturuluyor...',
        '生成视频': 'Video Oluştur',
        'AI图片': 'AI Görsel',
        '精美图片': 'Bir metin açıklaması girin, AI sizin için harika bir görsel oluşturacaktır',
        '描述您想要的图片场景': 'İstediğiniz görsel sahnesini açıklayın, örneğin: Geleceğin şehri silueti, yanıp sönen neon ışıkları, siberpunk tarzı...',
        '生成图片': 'Görsel Oluştur',
        '强大功能': 'Güçlü Özellikler',
        '让视频创作变得简单有趣': 'Video oluşturmayı basit ve eğlenceli hale getirin',
        '案例展示': 'Örnekler',
        '来看看用户使用': 'Kullanıcıların oluşturduğu harika eserleri görün',
        '创作的精彩作品': 'kullanıcılar',
        '新闻资讯': 'Haberler',
        '了解': 'Keşfedin',
        '的最新动态和产品更新': 'en son haberler ve ürün güncellemeleri',
        '查看更多': 'Daha Fazla Gör',
        '热门': 'Popüler',
        '最新': 'En Yeni',
        '阅读更多': 'Daha Fazla Oku',
        '选择适合您的方案': 'Size uygun planı seçin',
        '灵活的定价': 'Farklı ihtiyaçlar için esnek fiyatlandırma',
        '视频预览': 'Video Önizleme',
        '生成成功': 'Başarılı',
        '作品已保存到': 'Eser "Oluşturduklarım"a kaydedildi',
        '继续创作': 'Oluşturmaya Devam Et',
        '查看作品': 'Eseri Görüntüle',
        '请输入视频描述': 'Lütfen video açıklamasını girin',
        '视频生成成功！': 'Video başarıyla oluşturuldu!',
        '请输入图片描述': 'Lütfen görsel açıklamasını girin',
        '图片生成成功！': 'Görsel başarıyla oluşturuldu!',
    },
    News: {
        '新闻资讯': 'Haberler',
        '了解': 'Keşfedin',
        '的最新动态和产品更新': 'en son haberler ve ürün güncellemeleri',
        '精选': 'Seçtiklerimiz',
        '阅读': 'Oku',
        '点赞': 'Beğen',
        '热门': 'Popüler',
        '最新': 'En Yeni',
        '阅读更多': 'Daha Fazla Oku',
        '加载中': 'Yükleniyor...',
        '暂无新闻': 'Haber yok',
        '清除筛选': 'Filtreyi Temizle',
        '加载新闻失败': 'Haberler yüklenemedi, lütfen daha sonra tekrar deneyin',
    },
    Price: {
        '选择适合您的方案': 'Size uygun planı seçin',
        '灵活的定价': 'Farklı ihtiyaçlar için esnek fiyatlandırma',
        '包月': 'Aylık',
        '包年': 'Yıllık',
        '购买积分': 'Kredi Satın Al',
        '只需要几个视频': 'Sadece birkaç videoya mı ihtiyacınız var? Abonelik yok, doğrudan kredi paketi satın alın',
        '产品大全': 'Ürün Kataloğu',
        '了解': 'Keşfedin',
        '全系列产品的详细信息和支付方式': 'tüm ürün serisinin ayrıntılı bilgileri ve ödeme yöntemleri'
    },
    Billing: {
        '账单管理': 'Fatura Yönetimi',
        '账户余额': 'Hesap Bakiyesi',
        '本月支出': 'Bu Ayın Giderleri',
        '订单数量': 'Sipariş Sayısı',
        '账单列表': 'Fatura Listesi',
        '请选择类型': 'Lütfen tür seçin',
        '请选择时间范围': 'Lütfen zaman aralığı seçin',
        '订单号': 'Sipariş No',
        '类型': 'Tür',
        '金额': 'Tutar',
        '状态': 'Durum',
        '时间': 'Zaman',
        '操作': 'İşlem',
        '查看详情': 'Detayları Gör',
        '下载发票': 'Faturayı İndir',
        '暂无作品': 'Eser yok',
        '去创作': 'Oluşturmaya Git',
        '支付方式': 'Ödeme Yöntemi',
        '添加支付方式': 'Ödeme Yöntemi Ekle',
        '默认': 'Varsayılan',
        '设为默认': 'Varsayılan Yap',
        '编辑': 'Düzenle',
        '删除': 'Sil',
        '账单详情': 'Fatura Detayları',
        '交易流水号': 'İşlem Numarası',
        '关闭': 'Kapat',
        '账号': 'Hesap/Kart No',
        '请输入账号或卡号': 'Lütfen hesap veya kart numarasını girin',
        '姓名': 'Ad Soyad',
        '请输入持卡人姓名': 'Lütfen kart sahibinin adını girin',
        '有效期': 'Son Kullanma Tarihi',
        '请输入CVV码': 'Lütfen CVV kodunu girin',
        '取消': 'İptal',
        '确认添加': 'Eklemeyi Onayla',
        '确认修改': 'Değişikliği Onayla',
        '确认删除': 'Silmeyi Onayla',
        '编辑支付方式': 'Ödeme Yöntemini Düzenle',
        '确定要删除支付方式': 'Bu ödeme yöntemini silmek istediğinize emin misiniz?',
        '删除后不可恢复': 'Silme işlemi geri alınamaz, lütfen dikkatli olun!',
        '请输入账号': 'Lütfen hesap/kart numarasını girin',
        '添加成功': 'Başarıyla eklendi',
        '修改成功': 'Başarıyla değiştirildi',
        '已设为默认支付方式': 'Varsayılan ödeme yöntemi olarak ayarlandı',
        '删除成功': 'Başarıyla silindi',
    },
    Credit: {
        '额度管理': 'Kredi Yönetimi',
        '当前可用额度': 'Mevcut Kredi',
        '升级会员': 'Üyeliği Yükselt',
        '本月已用': 'Bu Ay Kullanılan',
        '视频生成': 'Video Oluşturma',
        'AI图片': 'AI Görsel',
        '其他': 'Diğer',
        '购买额度包': 'Kredi Paketi Satın Al',
        '最受欢迎': 'En Popüler',
        '额度': 'Kredi',
        '立即购买': 'Hemen Satın Al',
        '使用记录': 'Kullanım Geçmişi',
        '操作': 'İşlem',
        '类型': 'Tür',
        '额度变动': 'Kredi Değişimi',
        '时间': 'Zaman',
        '购买': 'Satın Al',
        '确认购买': 'Satın Almayı Onayla',
        '金额': 'Tutar: ',
        '获得': 'Kazan',
        '取消': 'İptal',
        '今天': 'Bugün',
        '昨天': 'Dün',
    },
    Dashboard: {
        '欢迎回来': 'Tekrar hoş geldiniz,',
        '创建新视频': 'Yeni Video Oluştur',
        '本月生成次数': 'Bu Ay Oluşturma Sayısı',
        '剩余额度': 'Kalan Kredi',
        '总视频数': 'Toplam Video Sayısı',
        '会员状态': 'Üyelik Durumu',
        '最近生成': 'Son Oluşturmalar',
        '查看全部': 'Tümünü Gör',
        '视频预览': 'Video Önizleme',
        '视频生成中': 'Video oluşturuluyor, önizleme için lütfen bekleyin',
    },
    Membership: {
        '会员中心': 'Üyelik Merkezi',
        '当前方案': 'Mevcut Plan',
        'Pro 会员': 'Pro Üyelik',
        '专业创作者首选': 'Profesyonel oluşturucuların ilk tercihi',
        '月': 'ay',
        '会员有效期': 'Üyelik Geçerlilik Süresi',
        '剩余天数': 'Kalan Gün',
        '续费会员': 'Üyeliği Yenile',
        '取消订阅': 'Aboneliği İptal Et',
        '本月使用情况': 'Bu Ay Kullanım Durumu',
        '视频生成': 'Video Oluşturma',
        '次': 'defa',
        '额度使用': 'Kredi Kullanımı',
        '快速生成': 'Hızlı Oluşturma',
        '升级方案': 'Planı Yükselt',
        '联系销售': 'Satışla İletişime Geç',
        '会员权益': 'Üyelik Avantajları',
        '续费后将延长会员有效期30天': 'Yenileme, üyelik süresini 30 gün uzatacaktır',
        '取消': 'İptal',
        '确认续费': 'Yenilemeyi Onayla',
        '取消后您将失去所有会员权益': 'İptal sonrası tüm üyelik avantajlarını kaybedersiniz, kalan krediniz korunur',
        '再想想': 'Tekrar Düşün',
        '确认取消': 'İptali Onayla',
        '姓名': 'Ad Soyad',
        '请输入您的姓名': 'Lütfen adınızı girin',
        '请输入姓名': 'Lütfen adı girin',
        '公司': 'Şirket',
        '请输入公司名称': 'Lütfen şirket adını girin',
        '邮箱': 'E-posta',
        '请输入邮箱地址': 'Lütfen e-posta adresini girin',
        '请输入邮箱': 'Lütfen e-postayı girin',
        '请输入正确的邮箱格式': 'Lütfen geçerli bir e-posta formatı girin',
        '需求': 'İhtiyaç',
        '请描述您的需求': 'Lütfen ihtiyacınızı açıklayın',
        '提交': 'Gönder',
        '请填写需求': 'Lütfen ihtiyacınızı belirtin',
        '续费成功': 'Yenileme başarılı! Üyelik süresi uzatıldı',
        '已取消订阅': 'Abonelik iptal edildi, üyelik süre sonunda sona erecektir',
        '提交成功': 'Başarıyla gönderildi, en kısa sürede size ulaşacağız!',
    },
    Task: {
        '生成任务': 'Oluşturma Görevleri',
        '新建任务': 'Yeni Görev',
        '进行中': 'Devam Ediyor',
        '已完成': 'Tamamlandı',
        '失败': 'Başarısız',
        '队列中': 'Sırada',
        '活跃任务': 'Aktif Görevler',
        '刷新': 'Yenile',
        '暂无活跃任务': 'Aktif görev yok',
        '预计剩余': 'Tahmini Kalan Süre',
        '暂停': 'Duraklat',
        '继续': 'Devam Et',
        '取消': 'İptal',
        '最近完成': 'Son Tamamlananlar',
        '查看全部': 'Tümünü Gör',
        '暂无完成的任务': 'Tamamlanan görev yok',
        '播放': 'Oynat',
        '下载': 'İndir',
        '分享': 'Paylaş',
        '确认取消': 'İptali Onayla',
        '确定要取消任务吗': 'Görevi iptal etmek istediğinize emin misiniz?',
        '已消耗的额度将无法退还': 'Kullanılan krediler iade edilmeyecektir',
        "返回": "Geri",
        "分享作品": "Paylaş",
        "复制链接": "Bağlantıyı kopyala",
        "任务列表已刷新": "Yenilendi",
        "已暂停": "Duraklatıldı",
        "生成中": "Oluşturuluyor",
        "已恢复": "Devam ediyor",
        "任务已取消": "İptal edildi",
        "链接已复制到剪贴板": "Bağlantı kopyalandı",
    },
    VideoShow: {
        '示例': 'Örnekler',
        '来自我们演示库的一套精心挑选的剪辑片段，点击任何卡片即可开始生成与之风格相似的素材。': 'Demo kütüphanemizden özenle seçilmiş klipler koleksiyonu. Benzer tarzda içerik oluşturmaya başlamak için herhangi bir karta tıklayın.',
        '全部': 'Tümü',
        '电影感': 'Sinematik',
        '角色': 'Karakterler',
        '产品': 'Ürünler',
        '自然': 'Doğa',
        '趣味': 'Eğlenceli',
        '加载中': 'Yükleniyor',
        '暂无展示': 'Demo mevcut değil',
        '视频预览': 'Video Önizleme',
    },
    Request: {
        '加载中': 'Yükleniyor...',
        '您已退出登录': 'Oturumunuz kapatıldı, tekrar giriş yapabilirsiniz',
        '确认退出': 'Çıkışı Onayla',
        '重新登录': 'Tekrar Giriş Yap',
        '错误': 'Hata',
        '网络错误': 'Ağ Hatası',
        '下载中': 'İndiriliyor...'
    },
    Other: {
        '剩余额度': 'Kalan Bakiye',
        '去登录': 'Giriş Yap',
        '请登录后查看': 'Lütfen görüntülemek için giriş yapın',
        '任务': 'Görev',
        '可在「生成任务」中查看详情': '，detayları "Oluşturma Görevleri" bölümünde görebilirsiniz',
        '查看详情': 'Detayları Gör',
        '排队中': 'Sırada',
        '运行中': 'Çalışıyor',
        '取消': 'İptal',
        '成功': 'Başarılı',
        '失败': 'Başarısız',
        '超时': 'Zaman Aşımı',
        '最后更新': 'Son Güncelleme:',
        '视频生成': 'Video Oluşturma',
        '活跃用户': 'Aktif Kullanıcılar',
        '用户评分': 'Kullanıcı Puanı',
        '万': 'bin',
        '快速生成': 'Hızlı Oluşturma',
        '先进的AI模型': 'Dakikalar içinde yüksek kaliteli videolar üreten gelişmiş yapay zeka modelleri',
        '多种风格': 'Çoklu Stiller',
        '多种风格任您选择': 'Gerçekçi, anime, sanatsal ve daha fazlası, seçiminize göre',
        '高清输出': 'Yüksek Çözünürlüklü Çıktı',
        '支持4K超高清视频输出': '4K ultra yüksek çözünürlüklü video çıktısını destekler, ayrıntılar net bir şekilde görünür',
        '商用授权': 'Ticari Lisans',
        '生成的视频可用于商业用途': 'Oluşturulan videolar ticari amaçlarla kullanılabilir, telif hakkı endişesi yoktur',
        '原价': 'Orijinal Fiyat',
        '积分价格说明': 'Kredi Fiyat Açıklaması',
        '系列': 'Seri',
        '模型': 'Model',
        '分辨率': 'Çözünürlük',
        '积分': 'Kredi',
        '秒': 'saniye',
        '秒示例': 'saniye (örnek)',
        '图片模型': 'Görsel Modeli',
        '图片为': 'Görsel',
        '系列产品': 'Seri ürünleri, şu anda desteklenen',
        '支持使用任意机型查看完身体验': '，tam deneyim için herhangi bir cihazı kullanmayı destekler.',
        '计费方式': 'Faturalandırma Yöntemi',
        '张': 'görsel',
        '按生成张数计费': 'Oluşturulan görsel sayısına göre faturalandırma',
        '普通用户': 'Normal Kullanıcı',
        '无记录': 'Kayıt yok',
        '总支出': 'Toplam Harcama',
        '月总使用': 'Aylık Toplam Kullanım',
        '月视频使用': 'Aylık Video Kullanımı',
        '月图片使用': 'Aylık Görsel Kullanımı',
        '生成成功': 'Oluşturma Başarılı',
        '视频总生成': 'Toplam Oluşturulan Video',
        '图片总生成': 'Toplam Oluşturulan Görsel',
        '生成中': 'Oluşturuluyor, lütfen 1-3 dakika bekleyin',
        '来自我们演示库的一套精心挑选的剪辑片段': 'Demo kitaplığımızdan özenle seçilmiş bir klipler koleksiyonu.',
        '最近7天': 'Son 7 gün',
        '最近30天': 'Son 30 gün',
        '本月': 'Bu ay',
        '上月': 'Geçen ay',
    }
}
